import { ThisReceiver } from "@angular/compiler";
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GoogleMap, MapInfoWindow, MapMarker } from "@angular/google-maps";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import * as _ from "lodash";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subject, debounceTime } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";

declare var google: any;
declare let L: {
  icon: (arg0: {
    iconUrl: string;
    iconSize: number[];
    iconAnchor: number[];
    popupAnchor: number[];
  }) => any;
};
declare var $: any;

@Component({
  selector: "app-admin-track",
  templateUrl: "./admin-track.component.html",
  styleUrls: ["./admin-track.component.css"],
})
export class AdminTrackComponent implements OnInit, OnDestroy {
  adminTrack: FormGroup;
  token: any;
  inititalCoordinates: any;
  mapConfigurations: any;
  markerArray: any[] = [];
  truckNo: any = "";
  distanceKM: number = 0;
  truckSearchOn = false;
  zoom = 4;
  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: "./assets/img/truck_icon1.png",
    opacity: 0.7,
  };
  markerOptionsNormal: google.maps.MarkerOptions = {
    draggable: false,
    icon: "./assets/img/truck_icon_green.svg",
    opacity: 0.7,
  };
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  completePickUpAddress: any;
  pickup_short_name: any = "";
  pickup_long_name: any = "";
  pickup_postal_code: any;
  dropAutoComplete: any;
  dropLocation!: ElementRef;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any | undefined;

  @ViewChild("dropLocationSearchField")
  markerOptionsSpecial: google.maps.MarkerOptions = {
    draggable: false,
    icon: "./assets/img/special_truck_icon.png",
    opacity: 0.7,
  };

  markerPositions: any = [];
  markerPositionsTemp: any = [];
  info!: MapInfoWindow;
  center: google.maps.LatLngLiteral = { lat: 21.14, lng: 79.08 };
  radiusCircle: google.maps.Circle | undefined;
  maxZoom = 15;
  minZoom = 8;
  options: google.maps.MapOptions = {
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    mapTypeId: "roadmap",
    maxZoom: this.maxZoom,
    minZoom: this.minZoom,
  };
  infoContent = "";
  trackArray: any = [];
  map: any;
  @ViewChild("map") mapElement: any;
  arrayMarker: any;
  page: any = 1;
  perPage: any = 10;
  truckNumber: any = -1;
  circle: any;
  geoFenceRadius: number = 30000;
  circleOptions: any;
  isLoading: boolean = false;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  intransit: boolean = false;
  truckStatus: boolean = false;
  zoomInterval: any; // Property to store interval reference
  isDisabled = false; // Set your condition here
  selectedTruck: any = null; // Track the selected truck
  intervalId: any;
  shouldGetTrack: boolean = true;
  resArray: any = [];
  address: any;
  subscriptions: any[] = [];
  isSelectedTruck: any;
  isReset = true;
  statusOffline: string = "OFFLINE";
  truckOfflineStatus: boolean = false;
  trucksInRadius: any[] = []; // You can type it more specifically if needed
  isDistanceFieldDisabled: boolean = true; // Initialize as true to disable by default
  dummyValue: any;
  // Declare a subject to debounce the search input
  searchInputChange = new Subject<string>();
  initialTruckData: any[] = []; // Store initial truck data
  isSearchButtonDisabled: boolean = true;

  constructor(
    private services: AdminService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    navigator.geolocation.getCurrentPosition((position) => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });

    this.adminTrack = this.fb.group({
      truckNo: [""],
    });

    let triptype = "track";
    localStorage.setItem("tripType", triptype);
  }

  // onInputKeyUp(event: any) {
  //   this.truckNo = event.target.value.toUpperCase();
  // }

  // Handles key up event and converts input to uppercase
  onInputKeyUp(event: any) {
    const value = event.target.value;
    if (value) {
      this.truckNo = value.toUpperCase();
    }
  }

  ngAfterViewInit(): void {
    var options = {
      componentRestrictions: { country: "in" },
    };
    if (this.shouldGetTrack) {
      this.getTrack();
    }

    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
  }

  addMarker(locationInfo: any) {
    // Check if the searched truck matches the current truck being processed
    const isSearchedTruck =
      locationInfo.truckNumber === this.truckNo ||
      locationInfo.driverName
        ?.toLowerCase()
        .includes(this.truckNo?.toLowerCase()) ||
      locationInfo.address?.toLowerCase().includes(this.truckNo?.toLowerCase());

    // If it's not the searched truck and no truck is searched, add the marker
    if (!this.truckNo || isSearchedTruck) {
      let truckLocDetails = this.markerPositions.find((item: any) => {
        return item.truckNumber === locationInfo.truckNumber;
      });

      if (
        !truckLocDetails ||
        (truckLocDetails.location &&
          (truckLocDetails.location.lat !== locationInfo.location.lat ||
            truckLocDetails.location.lng !== locationInfo.location.lng))
      ) {
        this.markerPositions = this.markerPositions.filter(
          (item: any) => item.truckNumber !== locationInfo.truckNumber
        );
        this.markerPositions.push(locationInfo);
      }
    }
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.truckNo);
  }

  geoCodePickUp(address: any) {
    google.maps?.event?.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();

        geoCoder.geocode(
          { address: place.formatted_address },
          (results: any, status: any) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              geoCoder.geocode({ location: latlong }, (result: any) => {
                this.completePickUpAddress = result[0];
                this.pickup_short_name = "";
                this.pickup_long_name = "";
              });
            }
          }
        );

        // Set truck number to the formatted address from the geocode result
        this.truckNo = place.formatted_address;
        // Trigger truck search based on the geocoded address
        this.onTruckNumberChange({ target: { value: this.truckNo } });
      }
    );
  }

  getTrack() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.isLoading = true;

    // Fetch truck data periodically or once
    const subscription = this.services
      .Track(this.token)
      .subscribe((response: any) => {
        this.resArray = response.body.record;
        this.resArray = this.resArray.map((item: any) => {
          item.truck_location_history =
            item.truck_location_history_dynamic || item.truck_location_history_static;
          return item;
        }).filter((item: any) => item.truck_location_history);

        // Store initial data once
        if (this.initialTruckData.length === 0) {
          this.initialTruckData = [...this.resArray];
        }

        if (this.shouldGetTrack) {
          this.trackArray = this.resArray;
        }

        if (response.status === 200) {
          this.isLoading = false;

          // Clear current markers if needed
          this.clearPreviousTruckLocation();

          // Add markers
          for (let i = 0; i < this.resArray.length; i++) {
            this.addMarker({
              trip_id: this.resArray[i]?.tripdetails?.trip_id,
              tripdetails: this.resArray[i]?.tripdetails,
              truckNumber:
                this.resArray[i]?.truck_location_history?.vehicleNumber,
              mobile: this.resArray[i]?.driverDetails?.mobile,
              driverName: this.resArray[i]?.driverDetails?.username,
              truckStatus:
                this.resArray[i]?.driverRouteDetails?.driver_route_status,
              startdate:
                this.resArray[i]?.truck_location_history?.trackDateTime,
              tripStatus:
                this.resArray[i]?.tripdetails?.trip_status,
              address: this.resArray[i]?.truck_location_history?.address,
              updateDate: this.resArray[i]?.truck_location_history?.createdAt,
              location: {
                lat: Number(this.resArray[i]?.truck_location_history?.latitude),
                lng: Number(
                  this.resArray[i]?.truck_location_history?.longitude
                ),
              },
              geofenceRadius: this.resArray[i]?.geofenceRadius,
            });
          }
        }
      });

    this.subscriptions.push(subscription);
  }

  getMarkerOptions(markerPosition: any): google.maps.MarkerOptions {
    let iconPath = "";
    if (
      markerPosition.truckStatus === "online" ||
      markerPosition.tripdetails?.trip_status == "completed"
    ) {
      iconPath = "/assets/img/truck_green.png";
    }
    if (
      markerPosition.truckStatus === "offline" ||
      markerPosition.truckStatus === "null" ||
      markerPosition.truckStatus === undefined ||
      markerPosition.truckStatus === ""
    ) {
      iconPath = "/assets/img/truck_gray.png";
    }
    if (
      markerPosition.truckStatus === "online" &&
      markerPosition.tripdetails?.trip_status == "tripstarted"
    ) {
      iconPath = "/assets/img/truck_blue.png";
    }
    if (
      markerPosition.truckStatus === "online" &&
      markerPosition.tripdetails?.trip_status == "inprogress"
    ) {
      iconPath = "/assets/img/truck_blue.png";
    }

    return {
      draggable: false,
      icon: iconPath,
      opacity: 0.7,
    };
  }
  marker(item: any, i: any) {
    this.arrayMarker = item;

    if ((!this.arrayMarker.address || String(this.arrayMarker.address).toLowerCase() === 'unknown') && this.arrayMarker.location?.lat && this.arrayMarker.location?.lng) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat: Number(this.arrayMarker.location.lat), lng: Number(this.arrayMarker.location.lng) } }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results && results.length) {
          this.arrayMarker.address = results[0].formatted_address;
        }
      });
    }

    if (
      this.arrayMarker?.truckStatus === "null" ||
      this.arrayMarker?.truckStatus === undefined ||
      this.arrayMarker?.truckStatus === ""
    ) {
      this.truckOfflineStatus = true;
      this.intransit = false;
      this.truckStatus = false;
    }
    if (this.arrayMarker?.truckStatus === "offline") {
      this.intransit = false;
      this.truckStatus = true;
      this.truckOfflineStatus = false;
    }
    if (this.arrayMarker?.truckStatus === "online") {
      this.intransit = false;
      this.truckStatus = true;
      this.truckOfflineStatus = false;
    }
    if (
      (this.arrayMarker.truckStatus === "online" &&
        this.arrayMarker.tripdetails?.trip_status === "tripstarted") ||
      (this.arrayMarker.truckStatus === "online" &&
        this.arrayMarker.tripdetails?.trip_status === "inprogress")
    ) {
      this.truckOfflineStatus = false;
      this.truckStatus = false;
      this.intransit = true;
    }
    $("#myModal").modal("show");
  }

  // Convert address to LatLng using Geocoder
  getLatLngFromAddress(address: string): Promise<google.maps.LatLng | null> {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const location = results[0].geometry.location;
          resolve(location);
        } else {
          reject(
            new Error(
              "Geocode was not successful for the following reason: " + status
            )
          );
        }
      });
    });
  }

  checkMatch(targetString: any, userInput: any): boolean {
    if (!targetString || !userInput) {
      return false;
    }

    const target = targetString.toLowerCase().trim();
    let userInput1 = userInput
      .toLowerCase()
      .replace(/\bindia\b/g, "")
      .trim();
    const parts = target.split(",").map((part: any) => part.trim());

    for (let part of parts) {
      if (userInput1.includes(part)) {
        return true;
      }
    }

    return false;
  }

  zoomToLocation(location: any, targetZoom: number) {
    const initialZoom = this.zoom;
    const zoomStep = 0.2;
    const zoomInterval = 50;

    const smoothZoom = (currentZoom: number) => {
      if (currentZoom < targetZoom) {
        this.zoom = 10;
        this.zoom = currentZoom;
        this.center = location;

        setTimeout(() => smoothZoom(currentZoom + zoomStep), zoomInterval);
      } else {
        this.zoom = targetZoom;
        this.center = location;
      }
    };

    smoothZoom(initialZoom);
  }

  onTruckNumberChange(eve: any) {
    this.truckNo = eve.target.value.trim();
    this.isSearchButtonDisabled = this.truckNo.length <= 3; // Update disabled state

    const inputValue = eve.target.value.trim().toLowerCase() || this.truckNo;

    // Show snack bar if the input is cleared
    if (inputValue === "") {
      this.markerPositionsTemp = this.initialTruckData;
      this.markerPositions = this.initialTruckData;
      this.trackArray = this.initialTruckData;

      // this.snackBar.open("Please provide correct data.", "Close", {
      //   duration: 3000,
      // });
    }

    const matchingTrucks = this.markerPositions.filter(
      (truck: any) =>
        truck.truckNumber?.toLowerCase() === inputValue ||
        truck.driverName?.toLowerCase() === inputValue ||
        truck.address?.toLowerCase() === inputValue
    );

    // Check if inputValue matches any truckNumber or driverName
    const isAnyMatch = this.markerPositions.some(
      (truck: any) =>
        truck.truckNumber?.toLowerCase().includes(inputValue) ||
        truck.driverName?.toLowerCase().includes(inputValue) ||
        truck.truckNumber?.toLowerCase().includes(this.truckNo) ||
        truck.driverName?.toLowerCase().includes(this.truckNo)
    );

    // Disable distance field if a match is found
    this.isDistanceFieldDisabled = matchingTrucks.length > 0 || isAnyMatch;

    // Check if the input is cleared or does not match the previous value
    if (inputValue !== this.dummyValue?.toLowerCase()) {
      // Show search button and hide clear button
      this.markerPositions = this.initialTruckData;
      this.markerPositionsTemp = this.initialTruckData;
      this.trackArray = this.initialTruckData;
      this.search_btn = true;
      this.clear_btn = false;
      this.distanceKM = 0;
      this.clearPreviousTruckLocation(); // Clear previous marker location if needed

      // Reset the markers to show all trucks from trackArray on the map without reload
      this.markerPositions = this.trackArray.map((item: any) => ({
        truckNumber: item.truck_location_history?.vehicleNumber,
        driverName: item.driverDetails?.username,
        address: item.truck_location_history?.address,
        location: {
          lat: parseFloat(item.truck_location_history?.latitude),
          lng: parseFloat(item.truck_location_history?.longitude),
        },

        tripStatus: item.tripdetails?.trip_status, //check

        truckStatus: item.driverRouteDetails?.driver_route_status || "",
        trip_id: item.tripdetails?.trip_id,
      }));

      // **Remove the radius from the map** by setting the circle to null or clearing it
      this.circle = {
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
        radius: 0,
      };
      // **Zoom out the map** to a default zoom level, such as 5 (to show a wider area)
      this.zoom = 4; // Set your desired zoom-out level here

      // Optionally center the map to a default location, such as the center of India
      this.center = { lat: 20.5937, lng: 78.9629 }; // Coordinates for India (you can change this)
    }
  }

  // on click Truck no. this function is called 
  searchTruckTrackInfo(eve: any, isRadius: boolean) {
    this.truckNo = "";
    this.isLoading = true;
    this.truckSearchOn = true;
    this.dummyValue = eve.trim();
    // Cache marker positions
    if (!this.markerPositionsTemp || this.markerPositionsTemp.length === 0) {
      this.markerPositionsTemp = [...this.trackArray];
    }

    // Map trackArray to marker positions
    this.markerPositions = this.trackArray.map((item: any) => ({
      truckNumber: item.truck_location_history?.vehicleNumber,
      driverName: item.driverDetails?.username,
      address: item.truck_location_history?.address,
      location: {
        lat: parseFloat(item.truck_location_history?.latitude),
        lng: parseFloat(item.truck_location_history?.longitude),
      },
      tripStatus: item.tripdetails?.trip_status,
      truckStatus: item.driverRouteDetails?.driver_route_status || "",
      trip_id: item.tripdetails?.trip_id,
      driverNumber: item.driverDetails?.mobile,
      pickUpdate: item.tripdetails?.pickup_date,
      updateTime: item.truck_location_history?.updatedAt,
    }));
    this.clearPreviousTruckLocation(); // Clear previous marker location
    this.isReset = true;

    if (eve && eve.trim() !== "") {
      this.truckNo = eve.trim();

      // Check distance condition
      // if (isRadius && this.distanceKM === 0 && !this.isDistanceFieldDisabled) {
      //   this.snackBar.open("Distance cannot be zero.", "Close", {
      //     duration: 3000,
      //   });
      //   this.isLoading = false;
      // }

      // Search for trucks by number, address, or driver name
      const matchedTruckMarkers = this.searchTruckByNumber(
        this.truckNo,
        isRadius
      );

      if (matchedTruckMarkers.length > 0) {
        const truckLocation = matchedTruckMarkers[0]?.location;
        this.zoomToLocation(truckLocation, 10); // Zoom to the truck location

        const radiusKM = this.distanceKM || 20;
        this.circle = {
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          center: truckLocation,
          radius: radiusKM * 1000,
        };

        this.center = truckLocation;
        this.checkTrucksInRadius(truckLocation, radiusKM * 1000, true); // Check nearby trucks
      } else {
        // Show all trucks
        // this.markerPositions = [...this.markerPositionsTemp];
        this.isDistanceFieldDisabled = true;
        // Try fetching location by address if no match is found
        this.getLatLngFromAddress(this.truckNo)
          .then((location) => {
            if (location) {
              const truckLocation = {
                lat: location.lat(),
                lng: location.lng(),
              };
              this.setTruckLocationAndRadius(truckLocation, 20);

              if (isRadius) {
                this.checkTrucksInRadius(truckLocation, 20 * 1000, true);
              }
            }
          })
          .catch((error) => {});
      }

      // Show clear button after searching
      this.search_btn = false;
      this.clear_btn = true;
    } else {
      this.markerPositions = this.initialTruckData;
      this.markerPositionsTemp = this.initialTruckData;
      this.trackArray = this.initialTruckData;
      // If search input is empty
      this.snackBar.open("Please provide correct data.", "Close", {
        duration: 3000,
      });
      // Reset map and markers if search input is cleared
      this.clear_btn = false;
      this.search_btn = true;
      this.markerPositions = [...this.markerPositionsTemp]; // Restore cached marker positions
      // Re-enable the distance field since no search is active
      this.isDistanceFieldDisabled = false;
    }

    this.isLoading = false;
  }

  // Helper function to handle setting truck location and radius
  setTruckLocationAndRadius(
    location: { lat: number; lng: number },
    radiusKM: number
  ) {
    this.zoomToLocation(location, 10); // Zoom into the new location

    this.circle = {
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      center: location,
      radius: radiusKM * 1000,
    };

    this.center = location;
    this.checkTrucksInRadius(location, radiusKM * 1000, true); // Check nearby trucks
  }

  // Function to search for trucks by truck number or driver name
  searchTruckByNumber(truckNumberOrDriver: string, isRadius: boolean) {
    const normalizedInput = truckNumberOrDriver.trim().toLowerCase();

    let filteredTrucks: any = []; // Declare filteredTrucks
    let specificTruck: any = null; // To store the specific truck if found

    // If searching within a radius
    if (isRadius && this.distanceKM > 0) {
      this.search_btn = false;
      this.clear_btn = true;

      // First, check if the input is a location address
      const isAddressSearch = this.checkMatch(normalizedInput, normalizedInput);

      if (isAddressSearch) {
        // Handle address search as before
        return this.getLatLngFromAddress(normalizedInput)
          .then((location) => {
            if (location) {
              const truckLocation = {
                lat: location.lat(),
                lng: location.lng(),
              };

              // Filter trucks based on distance
              filteredTrucks = this.markerPositions.filter((item: any) => {
                const distance = this.getDistance(
                  truckLocation.lat,
                  truckLocation.lng,
                  item.location.lat,
                  item.location.lng
                );
                return distance <= this.distanceKM; // Check if within the specified radius
              });

              // Update trackArray and markerPositions with filtered trucks
              this.trackArray = filteredTrucks; // Show all matching trucks in the map
              this.markerPositions = [...this.trackArray];

              // Return all matched trucks to show on the map
              return filteredTrucks;
            } else {
              return []; // Return an empty array if no location is found
            }
          })
          .catch((error) => {
            return []; // Handle errors gracefully
          });
      } else {
        // Filter by truck number
        specificTruck = this.markerPositions.find(
          (item: any) => item.truckNumber?.toLowerCase() === normalizedInput
        );

        // If the specific truck is found, add it to the filtered trucks array
        if (specificTruck) {
          filteredTrucks.push(specificTruck);
        }

        // Now filter trucks based on distance
        const trucksInRadius = this.markerPositions.filter((item: any) => {
          const distance = this.getDistance(
            specificTruck.location.lat,
            specificTruck.location.lng,
            item.location.lat,
            item.location.lng
          );
          return distance <= this.distanceKM; // Check if within the specified radius
        });

        // Combine the specific truck with other trucks in the radius
        filteredTrucks = Array.from(
          new Set([...filteredTrucks, ...trucksInRadius])
        );

        // Update trackArray and markerPositions
        this.trackArray = filteredTrucks; // Show all matching trucks in the map
        this.markerPositions = [...this.trackArray];

        return filteredTrucks;
      }
    } else {
      // Filter by truck number or driver name without radius
      filteredTrucks = this.markerPositions.filter(
        (item: any) =>
          item.truckNumber?.toLowerCase().includes(normalizedInput) ||
          item.driverName?.toLowerCase().includes(normalizedInput)
      );

      // If exactly one truck is found, zoom into it
      if (filteredTrucks.length === 1) {
        this.clear_btn = true;
        this.search_btn = false;
        this.markerPositions = filteredTrucks;

        return filteredTrucks;
      }
    }

    // Always return an array at the end
    return filteredTrucks.length > 0 ? filteredTrucks : [];
  }

  checkTrucksInRadius(
    location: google.maps.LatLngLiteral,
    radius: number,
    zoom: boolean
  ) {
    const trucksInRadius = this.markerPositions.filter((marker: any) => {
      const distance = this.getDistance(
        location.lat,
        location.lng,
        marker.location.lat,
        marker.location.lng
      );
      return distance <= radius / 1000; // Convert radius to kilometers
    });

    if (trucksInRadius.length > 0) {
      this.trucksInRadius = trucksInRadius;
      if (zoom) {
        this.zoomToLocation(trucksInRadius[0].location, 10);
      }
    } else {
    }
  }

  // Calculate the distance between two points using the Haversine formula
  getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
  }

  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  calculateZoomLevel(markerPositions: any) {
    const numMarkers = markerPositions.length;
    if (numMarkers < 10) {
      return 10;
    } else {
      return 8;
    }
  }

  randomLatLngWithinBounds(bounds: any): any {
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const lat = Math.random() * (ne.lat() - sw.lat()) + sw.lat();
    const lng = Math.random() * (ne.lng() - sw.lng()) + sw.lng();
    return new google.maps.LatLng(lat, lng);
  }
  resetTruckTrackInfo() {
    this.isLoading = true;
    this.isReset = false;
    this.getTrack();
    this.selectetheTruck(null);
    this.zoom = 4;
    this.truckNo = "";
    this.distanceKM = 0;
    this.truckSearchOn = false;
    this.clear_btn = false;
    this.search_btn = true;
    this.trackArray = this.resArray;

    this.markerPositions = [...this.markerPositionsTemp];
    this.circle = {
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      radius: 0,
    };
  }

  ngOnDestroy(): void {
    this.stopTracking();

    const interval_id = window.setInterval(function () {},
    Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }
  closeModel() {
    $("#myModal").modal("hide");
  }

  selectTruck(item: any, isRadius: boolean) {
    this.isLoading = true;
    this.truckNo = "";
    this.zoom = 4;
    this.isDisabled = true;
    this.selectedTruck = item || item.truckNumber; // Update the selected truck
    this.selectetheTruck(
      item.truck_location_history?.vehicleNumber || item.truckNumber
    );
    this.distanceKM = 0;
    this.clear_btn = true;
    this.search_btn = false;

    if (item.truck_location_history?.vehicleNumber || item.truckNumber) {
      this.truckNo =
        item.truck_location_history?.vehicleNumber || item.truckNumber;
      // Only show the selected truck on the map

      if (this.isReset == true) {
        this.markerPositions = this.trackArray.filter(
          (marker: any) =>
            marker.truck_location_history.vehicleNumber === this.truckNo
        );
      } else {
        this.markerPositions = this.markerPositions.filter(
          (marker: any) => marker.truckNumber === this.truckNo
        );

        this.isDistanceFieldDisabled = false;
      }

      this.searchTruckTrackInfo(this.truckNo, isRadius);
      this.stopTracking();
    } else {
      this.isLoading = false;
    }
    this.shouldGetTrack = false;
  }
  stopTracking() {
    // Function to cancel all pending requests
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });

    // Clear the subscriptions array
    this.subscriptions = [];
  }

  clearPreviousTruckLocation() {
    const previousLocationIndex = this.markerPositions.findIndex(
      (marker: any) => marker.isPrevious
    );
    if (previousLocationIndex !== -1) {
      this.markerPositions.splice(previousLocationIndex, 1);
    }

    this.circle = null;
  }

  selectetheTruck(truck: any) {
    this.isSelectedTruck = truck;
  }

  getTooltip(markerPosition: any): string {
    return `${markerPosition.driverName}\n${markerPosition.truckNumber}`;
  }
}
